import React from 'react';

import { useIntl } from 'react-intl';

import Currency from 'components/currency';

import { CurrencyLineSkeleton } from '../../currency-line-skeleton';

import { Total, TotalLabel, TotalsRow } from './styled';
import { RewardRow } from './subtotal.styled';
import { IRenderTotalsProps } from './types';
import { getFeesByGroup, getStandardizedName } from './utils';

export const RenderTotals: React.FC<IRenderTotalsProps> = ({
  cart = {},
  otherDiscountAmount,
  rewardDiscount,
  isLoading,
}) => {
  const { formatMessage } = useIntl();

  const { subTotalCents = 0 } = cart;

  const fees = cart.fees ?? [];
  const itemFees = getFeesByGroup(fees);

  const showRewardDiscount = !!rewardDiscount;

  return (
    <>
      {showRewardDiscount && (
        <RewardRow>
          {isLoading ? (
            <CurrencyLineSkeleton />
          ) : (
            <>
              <TotalLabel>
                {formatMessage({
                  id: 'rewardSavings',
                })}
              </TotalLabel>
              <Total data-testid="reward-savings">
                <Currency prefix="- " amount={rewardDiscount} />
              </Total>
            </>
          )}
        </RewardRow>
      )}
      {!!otherDiscountAmount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <RewardRow>
            <TotalLabel>
              {formatMessage({
                id: 'comboOfferSavings',
              })}
            </TotalLabel>
            <Total data-testid="discount-savings">
              <Currency prefix="- " amount={otherDiscountAmount} />
            </Total>
          </RewardRow>
        ))}

      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <TotalsRow>
          <TotalLabel>
            {formatMessage({
              id: 'subtotal',
            })}
          </TotalLabel>
          <Total data-testid="subtotal">
            <Currency amount={subTotalCents} />
          </Total>
        </TotalsRow>
      )}
      {!!itemFees &&
        Object.entries(itemFees).map(([name, entryCents]: [string, number], index) =>
          isLoading ? (
            <CurrencyLineSkeleton />
          ) : (
            <TotalsRow key={index}>
              <TotalLabel data-testid={`fee-name-${name}`}>
                {formatMessage({ id: `${getStandardizedName({ name })}Fee` })}
              </TotalLabel>
              <Total data-testid={`fee-amount-${name}`}>
                <Currency amount={entryCents} />
              </Total>
            </TotalsRow>
          )
        )}
    </>
  );
};

export default RenderTotals;
